module.exports = __webpack_public_path__ + "static/media/sindu.1629ef35.jpg";